export const FRANCHISE_FLAGS = {
  ca: 'assets/images/franchise/ca.svg',
  gb: 'assets/images/franchise/gb.svg',
  de: 'assets/images/franchise/de.svg',
};
